import { useState } from "react";

import { Table } from "../../../../components/Functional";
import { getInput } from "../../../../components/ui/Input";
import { FETCH_REPORT_TEMPLATES } from "../../../../graphql/query/ReportTemplate";

import Actions from "./components/Actions";
import Header from "../../../../components/ui/ListHeader";

const TYPE_OPTIONS = [
  { label: "All Types", value: "" },
  { label: "Artwork", value: "artwork" },
  { label: "Consignment", value: "consignment" },
  { label: "Contact", value: "contact" },
  { label: "Instance", value: "instance" },
  { label: "Invoice", value: "invoice" },
  { label: "Job", value: "job" },
  { label: "Offer", value: "offer" },
  { label: "Shipment", value: "shipment" },
  { label: "Warehouse", value: "warehouseitem" },
  { label: "Exhibition", value: "exhibition" },
];

const List = () => {
  const [typeFilter, setTypeFilter] = useState("");

  const tableProps = {
    variant: "dynamicHeight",
    dataKey: "reportTemplates",
    headers: [
      { label: "Name", name: "name", type: "label" },
      { label: "Type", name: "meta.type", type: "label" },
      {
        label: "Date / Time Last Updated",
        name: "updatedAt",
        type: "date-time",
      },
      { label: "", name: "action", type: "custom", component: Actions },
    ],
    inputs: [],
    FETCH_QUERY: FETCH_REPORT_TEMPLATES,
    variables: typeFilter ? { type: typeFilter } : {},
  };

  return (
    <>
      <Header
        leftText="Report Layouts"
        rightComponent={() => (
          <div className="w-full sm:min-w-[180px]">
            {getInput({
              label: "",
              name: "type",
              type: "select",
              options: TYPE_OPTIONS,
              formik: {
                values: { type: typeFilter },
                setFieldValue: (_, value) => setTypeFilter(value),
                getFieldProps: () => ({ value: typeFilter }),
                getFieldHelpers: () => ({
                  setValue: value => setTypeFilter(value),
                }),
              },
            })}
          </div>
        )}
      />
      <div className="mt-6 w-full overflow-x-auto px-4 sm:px-6 lg:px-8">
        <Table {...tableProps} />
      </div>
    </>
  );
};

export default List;
